// src/Routes/Tools/config/quizConfig.ts
import QuizRenderer from "../../../Components/HighLevelComponents/Tool/renderers/QuizRenderer";
import { ToolConfig } from "../../../Components/HighLevelComponents/Tool/types";

const quizConfig: ToolConfig = {
  id: "quiz",
  title: "Open Question Quiz Generator",
  description:
    "Generate open-ended questions and answers from any text to test knowledge and understanding.",
  inputs: [
    {
      id: "text-input",
      name: "text",
      label: "Source Text",
      description: "Enter the text you want to generate questions from",
      type: "textarea",
      required: true,
      placeholder: "Paste your text here...",
    },
    // Note: count and difficulty are handled by the Tool component directly
  ],
  promptId: 10, // ID of the quiz generator prompt (adjust if your ID is different)
  resultRenderer: QuizRenderer,
};

export default quizConfig;
